import FullLayout from '@/layouts/full/FullLayout.vue';
import type { RouteRecordRaw } from 'vue-router';

export const ativosRoutes: RouteRecordRaw[] = [
  {
    path: '/controladoria/ativos-clientes',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Ativos em Poder de Terceiros' },
    children: [
      {
        path: '',
        name: 'AtivosClientes',
        component: () => import('@/views/Controladoria/AtivosClientes/AtivosTerceiros.vue'),
        meta: {
          requiresAuth: true,
          title: 'Ativos em Poder de Terceiros',
          breadcrumb: 'Controladoria / Ativos Clientes',
        },
      },
    ],
  },
];

export default ativosRoutes;
